import React from 'react';

const Success = () => {
    return (
        <div className="">
            <h1 className="fw-bolder text-success">Thanks for Message</h1>
        </div>
    );
};

export default Success;